import { IOptionItem, IPaginationResponse } from '@wyz/types';
import { z } from 'zod';
import { IApplicationContext } from '~/common/types';
import { entitySchema, userCustomerSchema } from '~/connect/schemas';

export type ICustomer = z.infer<typeof entitySchema>;
export type IUserCustomer = z.infer<typeof userCustomerSchema> & {
  matchedTheme?: IApplicationContext['userTheme'];
  internalStockIds: Array<number>;
};
export type IMatchedCustomer = Pick<ICustomer, 'id' | 'code' | 'name'> & {
  deliveryInformation?: {
    country?: {
      currencyId: number;
    };
  };
  configuration: {
    dmsRef?: string;
  };
  supplierDmsRefDictionary: Record<number, string | null>;
};

export const CUSTOMER_CONTACT_TYPE = {
  LOGISTICS_CONTACT: 'LOGISTICS_CONTACT',
  ORDERS_CONTACT: 'ORDERS_CONTACT',
  QUOTES_CONTACT: 'QUOTES_CONTACT',
  REDISTRIBUTION_CONTACT: 'REDISTRIBUTION_CONTACT',
};

export type IUserCustomerPreview = {
  id: string;
  code: string;
  name: string;
  level: number;
  deliveryInformation: {
    city: string;
    zipCode: string;
    country: {
      currencyId: number;
    };
  };
  internalStocks: Array<{
    supplierId: number;
  }>;
};

export type IInternalStockSupplier = {
  supplier: {
    id: number;
    code: string | null;
    name: string;
  };
};

export type ISupplierTemplateSupplier = {
  wyzApiId: number;
  code: string | null;
  name: string;
  type: number;
  orderable: boolean | null;
  overridePriorityIfShorterDelivery: boolean | null;
  customName: string | null;
  status: string;
  rankingModelId: string | null;
  childCustomerDelivery: boolean;
  autoValidation: boolean;
  bestPriceDelay: boolean | null;
  extendedManufConfiguration: {
    enabled: boolean | null;
    warehouseId: string | null;
    displayName: string | null;
  } | null;
};

export type ICustomerDetail = ICustomer & {
  internalStockSuppliers: IInternalStockSupplier[];
  supplierTemplate: {
    suppliers: ISupplierTemplateSupplier[];
  } | null;
};

export type IContainerEligibleCustomerList = IPaginationResponse<ICustomer>;

export type ICustomerOption = IOptionItem & {
  city?: string;
  zipCode?: string;
  name: string;
};
